import { apolloClient } from "@/plugins/vue-apollo.js";

const updatePromotionCharge = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/fee/update_promotion_charges.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/fee/get_promotion_charges_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            }
          },
        };
        let allPromotionCharges = store.readQuery(query);
        const findIndex = allPromotionCharges.getAllPromotionCharges.promotionCharges.findIndex(
          (item) => item._id === data.updatePromotionCharge._id
        );
        findIndex !== -1 &&
          allPromotionCharges.getAllPromotionCharges.promotionCharges.splice(
            findIndex,
            1,
            data.updatePromotionCharge
          );
        store.writeQuery({
          ...query,
          data: allPromotionCharges,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updatePromotionCharge };
